import { render, staticRenderFns } from "./EditBranchAction.vue?vue&type=template&id=24b3cc94&scoped=true&"
import script from "./EditBranchAction.vue?vue&type=script&lang=ts&"
export * from "./EditBranchAction.vue?vue&type=script&lang=ts&"
import style0 from "./EditBranchAction.vue?vue&type=style&index=0&id=24b3cc94&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b3cc94",
  null
  
)

export default component.exports